import { defineMessages } from 'react-intl';

export default defineMessages({
  approvals: {
    id: 'frontbucket.commitList.approvals',
    description: 'Label for an icon indicating the commit has been approved',
    defaultMessage: 'Approvals',
  },
  srOnlyTagName: {
    id: 'frontbucket.commitList.srOnlyTagName',
    description: 'Text which provides tag label for screen readers',
    defaultMessage: 'Tag, ',
  },
  srOnlyBranchName: {
    id: 'frontbucket.commitList.srOnlyBranchName',
    description: 'Text which provides branch label for screen readers',
    defaultMessage: 'Branch, ',
  },
  tagsTooltip: {
    id: 'frontbucket.commitList.tagsTooltip',
    description: 'Text for tags tooltip',
    defaultMessage: '{count} tags',
  },
  branchesTooltip: {
    id: 'frontbucket.commitList.branchesTooltip',
    description: 'Text for branches tooltip',
    defaultMessage: '{count} branches',
  },
  emptyResultsHeading: {
    id: 'frontbucket.commits.filter.emptyResults.no.matches.heading',
    description:
      'Text for the title of the message displayed when no commits are returned after a filter is applied',
    defaultMessage: 'No commits match',
  },
  announceDisplayingAllCommits: {
    id: 'frontbucket.commits.filter.announceDisplayingAllCommits',
    description: "Announce displaying all commits, when filter doesn't applied",
    defaultMessage: 'All commits have been displayed',
  },
  announcerPaginatedFilterResults: {
    id: 'frontbucket.commits.filter.paginatedCommitsFound',
    description:
      'Text for the announcer of the message about found commits with pagination',
    defaultMessage:
      'Commits have been filtered, {count, plural, one {{count} commit was displayed} other {{count} commits have been displayed on this page, with more commits on the next page}}',
  },
  announcerFilterResults: {
    id: 'frontbucket.commits.filter.commitsFound',
    description: 'Text for the announcer of the message about found commits',
    defaultMessage:
      'Commits have been filtered, {count, plural, one {{count} commit has} other {{count} commits have}} been displayed',
  },
  announcerFilterProcess: {
    id: 'frontbucket.commits.filter.filteringProcess',
    description:
      'Text for the announcer of the message says that commits are filtering',
    defaultMessage: 'Filtering commits',
  },
  emptyResultsInfo: {
    id: 'frontbucket.commits.filter.emptyResults.no.matches.info',
    description:
      'Text for the information in the message displayed when no commits are returned after a filter is applied',
    defaultMessage: 'Try modifying your search criteria or {link}.',
  },
  emptyResultsLink: {
    id: 'frontbucket.commits.filter.emptyResults.no.matches.link',
    description:
      'Text for the link to view commits when no commits are returned after a filter is applied',
    defaultMessage: 'view all commits',
  },
});
